import * as React from "react";
const OSHAFDASVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M38.5 38.887a.875.875 0 0 1-.875.875h-19.25a.875.875 0 1 1 0-1.75h19.25a.875.875 0 0 1 .875.875Zm0-8.75v4.375a1.75 1.75 0 0 1-1.75 1.75h-17.5a1.75 1.75 0 0 1-1.75-1.75v-4.375a1.75 1.75 0 0 1 1.75-1.75h6.172l-1.718-8.016a3.499 3.499 0 0 1 3.421-4.234h1.75a3.5 3.5 0 0 1 3.422 4.234l-1.719 8.016h6.172a1.75 1.75 0 0 1 1.75 1.75Zm-11.289-1.75h1.578l1.797-8.384a1.752 1.752 0 0 0-1.711-2.116h-1.75a1.749 1.749 0 0 0-1.712 2.116l1.798 8.384Zm9.539 6.125v-4.375h-17.5v4.375h17.5Z"
    />
  </svg>
);
export default OSHAFDASVG;
